
'use client';

import { Header } from '@/components/header';
import { useAuth } from '@/components/providers/auth-provider';
import { Footer } from '@/components/footer';
import { EditableAboutImage } from '@/components/editable-about-image';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export function AboutPageContent() {
    const { user } = useAuth();

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1 container mx-auto px-4 py-8">
                <div className="max-w-3xl mx-auto">
                    <div className="text-center mb-12">
                         <EditableAboutImage />
                        <h1 className="text-4xl font-headline mb-2">Weston Deboer</h1>
                        <p className="text-xl text-muted-foreground">Founder of Art Vault</p>
                    </div>

                    <div className="prose dark:prose-invert lg:prose-lg mx-auto text-foreground/80 space-y-6">
                        <p>
                           Hi, my name is Weston Deboer. Collecting has always been a passion of mine. From an early age, I was captivated by the stories behind objects — whether a rare print, a unique poster, a beautifully crafted tool, or even a simple stamp. Over the years, that fascination grew into a lifelong pursuit of collecting and appreciating art and design.
                        </p>
                        <p>
                            I’ve also been programming for many years. In fact, this is the third time I’ve tried to build a version of this website — which probably says something about how much I believe in the idea. Each attempt has had the same goal: to create a simple, elegant way to track and explore art collections online.
                        </p>
                        <p>
                           Through my work with Shepard Fairey, I’ve been fortunate to gain a deeper look into the art world — its beauty, its complexity, and, yes, its chaos. One thing I’ve learned: no one fully understands the art world, and that’s exactly what makes it so compelling.
                        </p>
                        <p>
                           I created Art Vault because I saw a clear need. Too many collectors (myself included) were stuck tracking their collections in Google Sheets, FileMaker Pro, or expensive software that felt clunky and impersonal. I wanted a tool that was flexible, beautiful, and enjoyable to use — something I’d actually want to open every day.
                        </p>
                        <p>
                            Art Vault is built for collectors like me and my friends — people who love art and want to document, organize, and explore their collections in a better way. It isn’t meant to replace the experience of living with art, but to complement it: a place where your collection can live digitally, so you can enjoy it anywhere and discover what else is out there.
                        </p>
                         <p>
                           If this resonates with you, I’d love for you to sign up and start building your collection today — and help shape what Art Vault becomes next.
                        </p>
                    </div>
                    
                    {!user && (
                        <div className="mt-12 text-center">
                            <Button asChild size="lg">
                                <Link href="/my-collection">
                                    Sign Up & Start Collecting
                                    <ArrowRight className="ml-2" />
                                </Link>
                            </Button>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}
